export const manifest = {
  screens: {
    scr_un6x1o: { name: "1 · Executive headline", route: "/", state: {"currentIndex":0}, position: {"x":160,"y":220} },
    scr_9e8jag: { name: "2 · Snak journey drop-off", route: "/", state: {"currentIndex":1}, position: {"x":29560,"y":220} },
    scr_lmjwnz: { name: "3 · Strategy vs result", route: "/", state: {"currentIndex":2}, position: {"x":1560,"y":220} },
    scr_eqsofk: { name: "4 · Engagement", route: "/", state: {"currentIndex":3}, position: {"x":2960,"y":220} },
    scr_bpp2ch: { name: "5 · Industry benchmarks", route: "/", state: {"currentIndex":4}, position: {"x":14160,"y":220} },
    scr_w7k3ws: { name: "6 · Lead quality", route: "/", state: {"currentIndex":5}, position: {"x":28160,"y":220} },
    scr_gtw10b: { name: "7 · QR to aisle breaker", route: "/", state: {"currentIndex":6}, position: {"x":15560,"y":220} },
    scr_d7mdst: { name: "8 · Market signal", route: "/", state: {"currentIndex":7}, position: {"x":7160,"y":220} },
    scr_i3otm8: { name: "9 · Brand perception", route: "/", state: {"currentIndex":8}, position: {"x":8560,"y":220} },
    scr_7yteyp: { name: "10 · What we learned", route: "/", state: {"currentIndex":9}, position: {"x":19760,"y":220} },
    scr_k52mry: { name: "11 · Next improvements", route: "/", state: {"currentIndex":10}, position: {"x":25360,"y":220} },
    scr_byaaql: { name: "12 · Post-congress workflow", route: "/", state: {"currentIndex":11}, position: {"x":1560,"y":2200} },
    scr_1hs3c9: { name: "13 · Final recommendation", route: "/", state: {"currentIndex":12}, position: {"x":2960,"y":2200} },
  },
  sections: {
    sec_ozog4i: { name: "Marketing analysis presentation", x: 0, y: 0, width: 32320, height: 1180 },
    sec_1evdfc: { name: "Campaign execution", x: 0, y: 1980, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_ozog4i", children: [
      { kind: "screen", id: "scr_un6x1o" },
      { kind: "screen", id: "scr_lmjwnz" },
      { kind: "screen", id: "scr_eqsofk" },
      { kind: "screen", id: "scr_d7mdst" },
      { kind: "screen", id: "scr_i3otm8" },
      { kind: "screen", id: "scr_bpp2ch" },
      { kind: "screen", id: "scr_gtw10b" },
      { kind: "screen", id: "scr_7yteyp" },
      { kind: "screen", id: "scr_k52mry" },
      { kind: "screen", id: "scr_w7k3ws" },
      { kind: "screen", id: "scr_9e8jag" },
    ] },
    { kind: "section", id: "sec_1evdfc", children: [
      { kind: "screen", id: "scr_byaaql" },
      { kind: "screen", id: "scr_1hs3c9" },
    ] },
  ],
}
